import Button from "../../../fragments/Button";
import useWebSocket from "../../../hooks/useWebSocket";

/**
 * Idle game state.
 *
 * In the future we may show some
 * random facts that periodically change
 * about and the current leaderboard rankings.
 */
const Idle = ({ room, ready = true }) => {
  const { sendJson } = useWebSocket();
  return (
    <div className="flex flex-col items-center gap-y-4">
      <h1 className="text-3xl">{room.title}</h1>
      <p className="text-lg max-w-prose text-center">{room.description}</p>
      {ready ? (
        <Button
          primary
          onClick={() => sendJson({ type: "action", action: "start" })}
        >
          {gettext("Start Trivia!")}
        </Button>
      ) : (
        <Button disabled className="opacity-50">
          Connecting...
        </Button>
      )}
    </div>
  );
};
export default Idle;
